import React from 'react';

function CoinPackageCard({ package: pkg, onPurchase }) {
  return (
    <div className={`coin-package-card ${pkg.popular ? 'popular' : ''}`}>
      {pkg.popular && <div className="popular-badge">⭐ MÁS POPULAR</div>}
      
      <div className="package-icon">{pkg.icon}</div>
      <h3 className="package-name">{pkg.name}</h3>
      
      <div className="package-coins">
        <span className="coins-amount">{pkg.coins}</span>
        <span className="coins-label">💰 monedas</span>
      </div>
      
      <div className="package-price">
        <span className="price-amount">${pkg.price}</span>
        <span className="price-currency">USD</span>
      </div>
      
      {pkg.discount > 0 && (
        <div className="package-discount">
          {pkg.discount}% OFF
        </div>
      )}
      
      <button 
        className="purchase-button"
        onClick={() => onPurchase(pkg)}
      >
        COMPRAR
      </button>
    </div>
  );
}

export default CoinPackageCard;
